/* eslint-disable unicode-bom */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './SafetyReportPrint.css';

function SafetyReportViewerModal({ show, onClose, reportData, isLoading, printSections }) {
    const [selectedAppDocIndex, setSelectedAppDocIndex] = useState(0);
    const [localPrintSections, setLocalPrintSections] = useState({
        cover: true,
        prep: true,
        evals: true,
        photos: true,
        conclusion: true,
        meetings: true,
        trainings: true
    });

    useEffect(() => {
        if (show && printSections) {
            setLocalPrintSections(printSections);
        }
    }, [show, printSections]);

    if (!show) return null;

    const {
        project: selectedProj,
        processes: modalProcs,
        evaluations: modalEvals,
        summary: modalSummary,
        meetings: modalMeetings,
        trainings: modalTrainings,
        preparation: modalPreparation,
        useProcess: modalUseProcess,
        appDocsList
    } = reportData || {};

    const activeModal = 'TOTAL_PDF';
    const setActiveModal = (val) => { if (!val) onClose(); };
    const modalLoading = isLoading;

    const handlePrint = () => {
        const printContent = document.getElementById('printable-area');
        if (!printContent) return;

        const printWindow = window.open('', '_blank', 'width=1000,height=900');
        if (!printWindow) {
            alert('팝업 차단이 설정되어 있습니다. 브라우저 팝업 차단을 해제한 후 다시 시도해주세요.');
            return;
        }

        printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>위험성평가 보고서 출력</title>
          <base href="${window.location.origin}" />
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.0/font/bootstrap-icons.css">
          <style>
            @media print {
              @page { size: A4 landscape; margin: 12mm; }
              body { padding: 0 !important; background: #ffffff !important; color: #000000 !important; font-family: Pretendard, -apple-system, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
              .no-print { display: none !important; }
              .page-break { page-break-after: always !important; border: none !important; margin: 0 !important; padding: 0 !important; }
              .a4-page { min-height: 0 !important; padding: 0 !important; margin: 0 !important; border-bottom: none !important; }
              
              /* 표 강제 제어 (페이지 잘림 방지) */
              table { page-break-inside: auto !important; width: 100% !important; border-collapse: collapse !important; margin-bottom: 20px; font-size: 11px !important; }
              tr { page-break-inside: avoid !important; page-break-after: auto !important; }
              thead { display: table-header-group !important; }
              tfoot { display: table-footer-group !important; }
              
              /* 사진대지 그리드 */
              .photo-grid-container { display: grid !important; grid-template-columns: 1fr !important; gap: 15px !important; }
              .photo-card { page-break-inside: avoid !important; border: 1px solid #94a3b8 !important; padding: 10px !important; display: flex !important; flex-direction: column !important; }
            }
            body { padding: 25px; background: #ffffff; color: #000000; font-family: Pretendard, -apple-system, sans-serif; }
            .no-print { display: none !important; }
            .page-break { border-bottom: 2px dashed #94a3b8; padding-bottom: 40px; margin-bottom: 40px; position: relative; }
            .page-break:last-child { border-bottom: none; }
            @media print {
              .page-break::after { display: none !important; content: none !important; }
            }
            .page-break:not(:last-child)::after {
              content: '✂ 문서 구분선 (다음 페이지)';
              position: absolute;
              bottom: -11px;
              left: 50%;
              transform: translateX(-50%);
              background: #ffffff;
              padding: 0 15px;
              color: #64748b;
              font-size: 13px;
            }
            table { width: 100% !important; border-collapse: collapse !important; margin-bottom: 20px; font-size: 12px !important; }
            th, td { border: 1px solid #94a3b8 !important; padding: 8px 6px !important; text-align: center; vertical-align: middle !important; font-size: 11px !important; line-height: 1.45 !important; word-break: keep-all !important; word-wrap: break-word !important; }
            p { margin-top: 0 !important; margin-bottom: 0.2em !important; }
            th { background-color: #f8fafc !important; font-weight: bold !important; color: #0f172a !important; }
            .text-left, .text-start { text-align: left !important; }
            .section-title { font-size: 16px; font-weight: bold; margin-bottom: 12px; border-bottom: 2px solid #0f172a; padding-bottom: 6px; text-align: left; color: #0f172a; }
            .align-top-content p, .align-top-content { margin-top: 0 !important; margin-bottom: 0.2em !important; font-size: 11px !important; line-height: 1.45 !important; }
            .align-top-content * { font-size: 11px !important; }
            .align-top-content img { max-width: 100% !important; max-height: 380px !important; object-fit: contain !important; display: block; margin: 6px auto; }
            
            /* 사진대지 기본 화면용 (인쇄와 동일하게 유지) */
            .photo-grid-container { display: grid; grid-template-columns: 1fr; gap: 15px; }
            .align-top-content { vertical-align: top !important; }
            .photo-card { border: 1px solid #94a3b8; padding: 10px; display: flex; flex-direction: column; background: #f8fafc; }
          </style>
        </head>
        <body>
          <div>
            ${printContent.innerHTML}
          </div>
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.print();
              }, 500);
            };
            window.onafterprint = function() {
              window.close();
            };
          </script>
        </body>
      </html>
    `);
        printWindow.document.close();
    };

    if (!activeModal || !selectedProj || (activeModal !== 'TOTAL_PDF' && activeModal !== 'FULL' && activeModal !== 'SUMMARY')) return null;

    const projName = selectedProj?.name || '-';
    const projSite = selectedProj?.siteName || '-';
    const projPeriod = selectedProj?.period || '-';
    const projManager = selectedProj?.managerName || '-';

    const basicInfo = reportData?.basicInfo || {};
    // basicInfo에 등록된 사업장명(siteName)을 우선 사용하고 없으면 프로젝트 현장명을 사용
    const coverCompanyName = basicInfo.siteName || projSite;
    const coverCeoName = basicInfo.ceoName || '-';

    let coverAddress = basicInfo.address || '-';
    if (basicInfo.addressDetail && basicInfo.addressDetail.trim() !== '') {
        coverAddress = `${basicInfo.address} ${basicInfo.addressDetail}`;
    }
    if (basicInfo.zipcode && basicInfo.zipcode.trim() !== '') {
        coverAddress = `(${basicInfo.zipcode}) ${coverAddress}`;
    }
    const coverLogoUrl = basicInfo.logoUrl || '';

    // 전자결재 연동 문서 배열 파싱 및 선택 처리 (백엔드 API 조회 결과 활용)
    const appDocs = appDocsList || [];
    const currentAppDoc = appDocs.length > 0 ? appDocs[selectedAppDocIndex] : null;
    const currentAprvLines = currentAppDoc?.lines || selectedProj?.approval?.lines || [];

    // 기안/검토/승인 데이터 (프로젝트 DB 고정값 활용)
    let projWriter = selectedProj?.drafter || selectedProj?.writeName || '-';
    let projReviewer = selectedProj?.reviewer || '-';
    let projApprover = selectedProj?.approver || selectedProj?.managerName || '-';

    // 직위 정보
    let projWriterPos = selectedProj?.drafter_position || '';
    let projReviewerPos = selectedProj?.reviewer_position || '';
    let projApproverPos = selectedProj?.approver_position || '';

    // 결재일 정보 (done_date, doneDate, make_date 등)
    const formatDateStr = (dStr) => {
        if (!dStr) return '';
        try {
            const d = new Date(dStr);
            if (isNaN(d.getTime())) return '';
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        } catch (e) {
            return '';
        }
    };

    let projWriterDate = formatDateStr(selectedProj?.created_at || selectedProj?.createdAt || currentAppDoc?.make_date || currentAppDoc?.created_at);
    let projReviewerDate = '';
    let projApproverDate = formatDateStr(currentAppDoc?.updated_at || selectedProj?.updated_at || selectedProj?.updatedAt);

    // 결재선(lines) 데이터가 존재할 경우 유동적으로 덮어쓰기
    if (currentAprvLines && currentAprvLines.length > 0) {
        const len = currentAprvLines.length;

        // 기안자: 무조건 첫 번째 사람 [0]
        const draft = currentAprvLines[0];
        projWriter = draft?.name || draft?.user_name || draft?.userName || projWriter;
        projWriterPos = draft?.position || draft?.user_position || draft?.userPosition || projWriterPos;
        projWriterDate = formatDateStr(draft?.done_date || draft?.doneDate || draft?.updated_at || currentAppDoc?.make_date) || projWriterDate;

        if (len === 1) {
            projReviewer = '-';
            projReviewerPos = '';
            projReviewerDate = '';
            projApprover = '-';
            projApproverPos = '';
            projApproverDate = '';
        } else if (len === 2) {
            const approve = currentAprvLines[1];
            projReviewer = '-';
            projReviewerPos = '';
            projReviewerDate = '';
            projApprover = approve?.name || approve?.user_name || approve?.userName || projApprover;
            projApproverPos = approve?.position || approve?.user_position || approve?.userPosition || projApproverPos;
            projApproverDate = formatDateStr(approve?.done_date || approve?.doneDate || approve?.updated_at) || projApproverDate;
        } else {
            const review = currentAprvLines[1];
            const approve = currentAprvLines[len - 1];

            projReviewer = review?.name || review?.user_name || review?.userName || projReviewer;
            projReviewerPos = review?.position || review?.user_position || review?.userPosition || projReviewerPos;
            projReviewerDate = formatDateStr(review?.done_date || review?.doneDate || review?.updated_at);

            projApprover = approve?.name || approve?.user_name || approve?.userName || projApprover;
            projApproverPos = approve?.position || approve?.user_position || approve?.userPosition || projApproverPos;
            projApproverDate = formatDateStr(approve?.done_date || approve?.doneDate || approve?.updated_at) || projApproverDate;
        }
    }

    // 실제 공정 및 평가 데이터 (가짜 폴백 제거, 없으면 빈 배열)
    const rawProcs = Array.isArray(modalProcs) ? modalProcs : (modalProcs?.items || []);
    const rawEvals = Array.isArray(modalEvals) ? modalEvals : (modalEvals?.items || []);

    // 공정명(processName / process_name) 기준으로 동일 공정 항목들을 그룹 정렬
    const displayEvals = [...rawEvals].sort((a, b) => {
        const pA = String(a.processName || a.process_name || '');
        const pB = String(b.processName || b.process_name || '');
        return pA.localeCompare(pB, 'ko');
    });

    // 평가 결과(displayEvals)에 등록된 공정 이름들을 수집 (processName 또는 process_name 호환)
    const usedProcessNamesRaw = displayEvals.map(e => e.processName || e.process_name).filter(Boolean);
    const usedProcessNamesSet = new Set();

    usedProcessNamesRaw.forEach(rawName => {
        if (rawName === 'Process 1' || rawName === '기본 공정') return;
        const splitted = String(rawName).split(',').map(s => s.trim()).filter(Boolean);
        splitted.forEach(name => usedProcessNamesSet.add(name));
    });

    const usedProcessNames = [...usedProcessNamesSet];
    const uniqueProcsMap = new Map();

    usedProcessNames.forEach(name => {
        const normalizedName = name.replace(/\s+/g, '');
        const existingProc = rawProcs.find(p => p.name && p.name.replace(/\s+/g, '') === normalizedName);

        if (existingProc) {
            uniqueProcsMap.set(name, existingProc);
        } else {
            uniqueProcsMap.set(name, {
                id: `eval-${name}`,
                name: name,
                description: name.includes('사업장') ? '공통 위험요인 평가 대상' : '',
                machine: '',
                managerName: ''
            });
        }
    });
    const displayProcs = Array.from(uniqueProcsMap.values());

    // 1:N 회의록 및 교육일지 실제 데이터 매핑 (API 응답 기반)
    const displayMeetings = Array.isArray(modalMeetings) ? modalMeetings : (modalMeetings?.items || []);
    const displayTrainings = Array.isArray(modalTrainings) ? modalTrainings : (modalTrainings?.items || []);

    // 3x3 / 5x5 매트릭스 유형 감지
    const is5x5 = displayEvals.some(item => {
        const ev = item.evaluation || {};
        return (ev.freqBefore > 3 || ev.sevBefore > 3 || ev.riskBefore > 9 || ev.freqAfter > 3 || ev.sevAfter > 3 || ev.riskAfter > 9);
    });

    // 위험도 점수 등급 및 컬러 판정 함수
    const getRiskDisplay = (score) => {
        const num = parseInt(score, 10);
        if (isNaN(num)) return '-';

        let text = '';
        let color = '';
        let bg = '';

        if (is5x5) {
            if (num >= 12) { text = '상'; color = '#dc2626'; bg = '#fef2f2'; }
            else if (num >= 4) { text = '중'; color = '#d97706'; bg = '#fffbeb'; }
            else { text = '하'; color = '#16a34a'; bg = '#f0fdf4'; }
        } else {
            if (num >= 6) { text = '상'; color = '#dc2626'; bg = '#fef2f2'; }
            else if (num >= 3) { text = '중'; color = '#d97706'; bg = '#fffbeb'; }
            else { text = '하'; color = '#16a34a'; bg = '#f0fdf4'; }
        }

        return (
            <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '10.5px',
                fontWeight: 'bold',
                color: color,
                backgroundColor: bg,
                border: `1px solid ${color}40`,
                borderRadius: '4px',
                padding: '2px 5px',
                minWidth: '40px',
                whiteSpace: 'nowrap'
            }}>
                {num} ({text})
            </span>
        );
    };

    // 사진대지용 데이터: 사진(Before 또는 After)이 존재하는 항목만 추출 및 1줄 통합 경로/유해위험요인 파악 연동
    const displayPhotos = displayEvals
        .filter(e => {
            if (!e.evaluation) return false;
            const photos = e.evaluation.photos || [];
            const beforeObj = photos.find(p => p.type === 'before' || p.type?.toLowerCase().includes('before')) || (photos.length > 0 ? photos[0] : null);
            const afterObj = photos.find(p => p.type === 'after' || p.type?.toLowerCase().includes('after')) || (photos.length > 1 ? photos[1] : null);
            return Boolean(beforeObj || afterObj);
        })
        .map(e => {
            const photos = e.evaluation.photos || [];
            const beforeObj = photos.find(p => p.type === 'before' || p.type?.toLowerCase().includes('before')) || (photos.length > 0 ? photos[0] : null);
            const afterObj = photos.find(p => p.type === 'after' || p.type?.toLowerCase().includes('after')) || (photos.length > 1 ? photos[1] : null);

            const processStr = e.processName || e.process_name || '';
            const categoryStr = e.categoryName || e.category_name || '';
            const causeStr = e.causeCode ? `[${e.causeCode}] ${e.causeName}` : (e.causeName || '');
            const breadcrumb = [processStr, categoryStr, causeStr].filter(Boolean).join(' ➔ ');

            return {
                breadcrumb: breadcrumb || '-',
                currentMeasure: (e.evaluation && e.evaluation.currentMeasure) || e.memo || '-',
                before: beforeObj ? beforeObj.url : '',
                after: afterObj ? afterObj.url : ''
            };
        });

    // 공정명 Rowspan 계산 (중복 공정명이 빈칸으로 넘어오는 경우 대비 이전 값 상속)
    const rowSpans = [];
    let tempProcess = null;
    let count = 0;
    let startIndex = 0;
    displayEvals.forEach((item, idx) => {
        const currentProcName = item.processName || item.process_name || '';
        item.processName = currentProcName || tempProcess || '공정 미지정';

        if (item.processName !== tempProcess) {
            if (tempProcess !== null) {
                rowSpans[startIndex] = count;
            }
            tempProcess = item.processName;
            count = 1;
            startIndex = idx;
        } else {
            count++;
        }
    });
    if (tempProcess !== null) {
        rowSpans[startIndex] = count;
    }

    return ReactDOM.createPortal(
        <div
            className="print-modal-wrapper"
            style={{
                position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
                backgroundColor: 'rgba(15, 23, 42, 0.75)', zIndex: 999999,
                display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
                backdropFilter: 'blur(5px)'
            }}
            onClick={() => setActiveModal(null)}
        >
            <div
                className="bg-white rounded-3 shadow-lg border-0 overflow-hidden"
                style={{ width: '100%', maxWidth: '980px', minHeight: '550px', maxHeight: '92vh', display: 'flex', flexDirection: 'column', position: 'relative' }}
                onClick={e => e.stopPropagation()}
            >
                <style>{`
                    .align-top-content p, .align-top-content { margin-top: 0 !important; margin-bottom: 0.2em !important; font-size: 11px !important; line-height: 1.45 !important; }
                    .align-top-content * { font-size: 11px !important; }
                    .align-top-content img { max-width: 100% !important; max-height: 380px !important; object-fit: contain !important; display: block; margin: 6px auto; }
                `}</style>
                {/* 최상단 로딩 덮개 (스크롤 포함 모달 전체를 가림) */}
                {modalLoading && (
                    <div style={{
                        position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)', zIndex: 9999,
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
                    }}>
                        <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}></div>
                        <h5 className="fw-bold text-dark">데이터를 로드 중입니다...</h5>
                    </div>
                )}

                {/* 모달 상단 툴바 */}
                <div className="text-dark px-4 py-3.5 d-flex justify-content-between align-items-center no-print border-bottom" style={{ backgroundColor: '#e2e8f0', minHeight: '58px' }}>
                    <div className="d-flex align-items-center gap-2" style={{ maxWidth: '90%', overflow: 'hidden' }}>
                        <h5 className="fw-bold mb-0 text-dark text-truncate" style={{ fontSize: '1.15rem' }} title={(activeModal === 'TOTAL_PDF' || activeModal === 'FULL' || activeModal === 'SUMMARY') ? `[위험성평가 최종 결과 보고서] ${projName}` : ''}>
                            {(activeModal === 'TOTAL_PDF' || activeModal === 'FULL' || activeModal === 'SUMMARY') && `[위험성평가 최종 결과 보고서] ${projName}`}
                        </h5>
                    </div>
                </div>

                {/* 인쇄 대상 항목 선택 바 */}
                <div className="px-4 d-flex align-items-center gap-4 no-print" style={{ backgroundColor: '#f8fafc', fontSize: '0.85rem', flexWrap: 'wrap', minHeight: '46px', paddingTop: '10px', paddingBottom: '10px', borderBottom: '1px solid #cbd5e1' }}>
                    <span className="fw-bold text-secondary d-flex align-items-center gap-1" style={{ height: '100%' }}>
                        <i className="bi bi-check2-square text-primary" style={{ fontSize: '1rem', marginTop: '-2px' }}></i> 인쇄 대상 항목 선택:
                    </span>
                    <div className="d-flex align-items-center gap-3" style={{ flexWrap: 'wrap', height: '100%' }}>
                        <label className="d-inline-flex align-items-center cursor-pointer fw-semibold text-dark" style={{ userSelect: 'none', margin: 0, gap: '6px' }}>
                            <input type="checkbox" style={{ width: '15px', height: '15px', margin: 0, cursor: 'pointer', accentColor: '#2563eb' }} checked={localPrintSections.cover} onChange={(e) => setLocalPrintSections({ ...localPrintSections, cover: e.target.checked })} />
                            <span>표지</span>
                        </label>
                        <label className="d-inline-flex align-items-center cursor-pointer fw-semibold text-dark" style={{ userSelect: 'none', margin: 0, gap: '6px' }}>
                            <input type="checkbox" style={{ width: '15px', height: '15px', margin: 0, cursor: 'pointer', accentColor: '#2563eb' }} checked={localPrintSections.prep} onChange={(e) => setLocalPrintSections({ ...localPrintSections, prep: e.target.checked })} />
                            <span>사전준비/매트릭스</span>
                        </label>
                        <label className="d-inline-flex align-items-center cursor-pointer fw-semibold text-dark" style={{ userSelect: 'none', margin: 0, gap: '6px' }}>
                            <input type="checkbox" style={{ width: '15px', height: '15px', margin: 0, cursor: 'pointer', accentColor: '#2563eb' }} checked={localPrintSections.evals} onChange={(e) => setLocalPrintSections({ ...localPrintSections, evals: e.target.checked })} />
                            <span>평가표</span>
                        </label>
                        <label className="d-inline-flex align-items-center cursor-pointer fw-semibold text-dark" style={{ userSelect: 'none', margin: 0, gap: '6px' }}>
                            <input type="checkbox" style={{ width: '15px', height: '15px', margin: 0, cursor: 'pointer', accentColor: '#2563eb' }} checked={localPrintSections.photos} onChange={(e) => setLocalPrintSections({ ...localPrintSections, photos: e.target.checked })} />
                            <span>사진대지</span>
                        </label>
                        <label className="d-inline-flex align-items-center cursor-pointer fw-semibold text-dark" style={{ userSelect: 'none', margin: 0, gap: '6px' }}>
                            <input type="checkbox" style={{ width: '15px', height: '15px', margin: 0, cursor: 'pointer', accentColor: '#2563eb' }} checked={localPrintSections.conclusion} onChange={(e) => setLocalPrintSections({ ...localPrintSections, conclusion: e.target.checked })} />
                            <span>종합총평</span>
                        </label>
                        <label className="d-inline-flex align-items-center cursor-pointer fw-semibold text-dark" style={{ userSelect: 'none', margin: 0, gap: '6px' }}>
                            <input type="checkbox" style={{ width: '15px', height: '15px', margin: 0, cursor: 'pointer', accentColor: '#2563eb' }} checked={localPrintSections.meetings} onChange={(e) => setLocalPrintSections({ ...localPrintSections, meetings: e.target.checked })} />
                            <span>회의록</span>
                        </label>
                        <label className="d-inline-flex align-items-center cursor-pointer fw-semibold text-dark" style={{ userSelect: 'none', margin: 0, gap: '6px' }}>
                            <input type="checkbox" style={{ width: '15px', height: '15px', margin: 0, cursor: 'pointer', accentColor: '#2563eb' }} checked={localPrintSections.trainings} onChange={(e) => setLocalPrintSections({ ...localPrintSections, trainings: e.target.checked })} />
                            <span>교육일지</span>
                        </label>
                    </div>
                </div>

                {/* 모달 본문 영역 (A4 정식 보고서 UI) */}
                <div className="p-4 bg-white text-dark position-relative" id="printable-area" style={{ flex: 1, fontFamily: 'Pretendard, sans-serif', overflowY: modalLoading ? 'hidden' : 'auto' }}>

                    {(activeModal === 'TOTAL_PDF' || activeModal === 'FULL' || activeModal === 'SUMMARY') && (
                        <div className="p-3">

                            {/* 1P: 표지, 공정, 매트릭스 */}
                            {localPrintSections.cover && (
                                <div className="a4-page page-break">
                                    {coverLogoUrl && (
                                        <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-4 text-muted small" style={{ minHeight: '40px' }}>
                                            <div className="d-flex align-items-center">
                                                <img src={coverLogoUrl} alt="로고" style={{ height: '40px' }} />
                                            </div>
                                            <div className="text-end">
                                                <div>{/* 문서번호 연동 예정 */}</div>
                                                <div>{/* 보안등급 연동 예정 */}</div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="text-center pb-4 border-bottom mb-4" style={{ paddingTop: '15px' }}>

                                        <h1 style={{ fontSize: '2.5rem', fontWeight: 900, color: '#0f172a', marginBottom: '15px', letterSpacing: '-1px' }}>
                                            위험성평가 최종 결과 보고서
                                        </h1>
                                        <h3 className="text-primary fw-bold mb-3" style={{ fontSize: '1.4rem' }}>
                                            {projName}
                                        </h3>
                                        <style>{`
                                            #printable-area .cover-info-table th, 
                                            #printable-area .cover-info-table td,
                                            #printable-area .cover-approval-table th, 
                                            #printable-area .cover-approval-table td {
                                                font-size: 10pt !important;
                                                padding: 10px !important;
                                            }
                                            #printable-area .align-top-content {
                                                vertical-align: top !important;
                                            }
                                            /* 페이지 분할 선 추가 */
                                            #printable-area .page-break { border-bottom: 2px dashed #94a3b8; padding-bottom: 40px; margin-bottom: 40px; position: relative; }
                                            #printable-area .page-break:last-child { border-bottom: none; }
                                            @media print {
                                                #printable-area .page-break::after { display: none !important; content: none !important; }
                                            }
                                            #printable-area .page-break:not(:last-child)::after {
                                                content: '✂ 문서 구분선 (다음 페이지)';
                                                position: absolute;
                                                bottom: -11px;
                                                left: 50%;
                                                transform: translateX(-50%);
                                                background: #ffffff;
                                                padding: 0 15px;
                                                color: #64748b;
                                                font-size: 13px;
                                            }
                                        `}</style>
                                        <table className="table table-bordered mx-auto mb-4 align-middle cover-info-table" style={{ maxWidth: '700px' }}>
                                            <tbody>
                                                <tr>
                                                    <th className="table-light" style={{ width: '28%', background: '#f8fafc' }}>대 상 사 업 장</th>
                                                    <td className="fw-bold text-dark text-start px-4">{coverCompanyName}</td>
                                                </tr>
                                                <tr>
                                                    <th className="table-light" style={{ background: '#f8fafc' }}>대 표 자 명</th>
                                                    <td className="fw-bold text-dark text-start px-4">{coverCeoName}</td>
                                                </tr>
                                                <tr>
                                                    <th className="table-light" style={{ background: '#f8fafc' }}>사 업 장 주 소</th>
                                                    <td className="text-dark text-start px-4">{coverAddress}</td>
                                                </tr>
                                                <tr>
                                                    <th className="table-light" style={{ background: '#f8fafc' }}>평 가 실 시 기 간</th>
                                                    <td className="text-start px-4">{projPeriod}</td>
                                                </tr>
                                                <tr>
                                                    <th className="table-light" style={{ background: '#f8fafc' }}>안 전 보 건 관 리 자</th>
                                                    <td className="fw-bold text-start px-4">{projManager}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div className="d-flex justify-content-center mt-3 mb-3">
                                            <table className="table table-bordered text-center align-middle cover-approval-table" style={{ maxWidth: '700px' }}>
                                                <thead>
                                                    <tr className="table-light" style={{ background: '#f8fafc' }}>
                                                        <th style={{ width: projReviewer !== '-' ? '33%' : '50%' }}>기안자 {projWriterPos && `(${projWriterPos})`}</th>
                                                        {projReviewer !== '-' && <th style={{ width: '33%' }}>검토자 {projReviewerPos && `(${projReviewerPos})`}</th>}
                                                        <th style={{ width: projReviewer !== '-' ? '34%' : '50%' }}>최종 승인자 {projApproverPos && `(${projApproverPos})`}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr style={{ height: '100px' }}>
                                                        <td className="align-bottom pb-2">
                                                            {projWriter !== '-' && (
                                                                <div className="d-flex flex-column align-items-center h-100 justify-content-end">
                                                                    <div className="d-flex align-items-center justify-content-center mb-2" style={{ width: '100%', height: '50px' }}>
                                                                        <span className="text-muted" style={{ opacity: 0.3, fontSize: '14px' }}>(인)</span>
                                                                    </div>
                                                                    <span className="fw-bold text-dark">{projWriter}</span>
                                                                    {projWriterDate && <span className="text-secondary small fw-normal mt-1" style={{ fontSize: '0.75rem' }}>{projWriterDate}</span>}
                                                                </div>
                                                            )}
                                                        </td>
                                                        {projReviewer !== '-' && (
                                                            <td className="align-bottom pb-2">
                                                                <div className="d-flex flex-column align-items-center h-100 justify-content-end">
                                                                    <div className="d-flex align-items-center justify-content-center mb-2" style={{ width: '100%', height: '50px' }}>
                                                                        <span className="text-muted" style={{ opacity: 0.3, fontSize: '14px' }}>(인)</span>
                                                                    </div>
                                                                    <span className="fw-bold text-dark">{projReviewer}</span>
                                                                    {projReviewerDate && <span className="text-secondary small fw-normal mt-1" style={{ fontSize: '0.75rem' }}>{projReviewerDate}</span>}
                                                                </div>
                                                            </td>
                                                        )}
                                                        <td className="align-bottom pb-2">
                                                            {projApprover !== '-' && (
                                                                <div className="d-flex flex-column align-items-center h-100 justify-content-end">
                                                                    <div className="d-flex align-items-center justify-content-center mb-2" style={{ width: '100%', height: '50px' }}>
                                                                        <span className="text-muted" style={{ opacity: 0.3, fontSize: '14px' }}>(인)</span>
                                                                    </div>
                                                                    <span className="fw-bold text-dark">{projApprover}</span>
                                                                    {projApproverDate && <span className="text-secondary small fw-normal mt-1" style={{ fontSize: '0.75rem' }}>{projApproverDate}</span>}
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* 2P: 사전준비 공정 목록 및 요인 파악 매트릭스 */}
                            {localPrintSections.prep && (
                                <div className="a4-page page-break">
                                    {/* 안전보건정보 (사전준비 10가지 체크표) */}
                                    <div className="section-title" style={{ marginTop: '10px', fontSize: '18px' }}>1. 사전준비(안전보건정보)</div>
                                    <table className="table table-bordered align-middle small mb-4 text-center">
                                        <thead className="table-light" style={{ background: '#f8fafc' }}>
                                            <tr>
                                                <th style={{ width: '7%' }}>No.</th>
                                                <th>점검 항목</th>
                                                <th style={{ width: '25%' }}>결과</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr><td>1</td><td className="text-start">최근 3년간 재해발생 사례</td><td>{modalPreparation?.accident_cnt != null ? `${modalPreparation.accident_cnt}건` : '-'}</td></tr>
                                            <tr><td>2</td><td className="text-start">아차사고 발생 사례</td><td>{modalPreparation?.near_miss_cnt != null ? `${modalPreparation.near_miss_cnt}건` : '-'}</td></tr>
                                            <tr><td>3</td><td className="text-start">작업환경측정 결과</td><td>{modalPreparation?.has_work_env_measure ? '■ 유 / □ 무' : '□ 유 / ■ 무'}</td></tr>
                                            <tr><td>4</td><td className="text-start">근로자 건강진단(특수건강진단) 결과</td><td>{modalPreparation?.has_health_check ? '■ 유 / □ 무' : '□ 유 / ■ 무'}</td></tr>
                                            <tr><td>5</td><td className="text-start">근로자 특성</td>
                                                <td className="text-start" style={{ paddingLeft: 8 }}>
                                                    {(() => {
                                                        try {
                                                            const raw = modalPreparation?.worker_characteristics || '[]';
                                                            const chars = typeof raw === 'string' ? JSON.parse(raw) : (Array.isArray(raw) ? raw : []);
                                                            const labelMap = { female: '여성', unskilled: '미숙련', senior: '고령자', foreigner: '외국인', disabled: '장애인', temporary: '일용단기' };
                                                            return chars.length > 0 ? chars.map(k => labelMap[k] || k).join(', ') : '-';
                                                        } catch { return '-'; }
                                                    })()}
                                                </td>
                                            </tr>
                                            <tr><td>6</td><td className="text-start">도급/용역/파견 사용 여부</td><td>{modalPreparation?.has_subcontract ? '■ 유 / □ 무' : '□ 유 / ■ 무'}</td></tr>
                                            <tr><td>7</td><td className="text-start">MSDS(물질안전보건자료) 유해성 정보</td><td>{modalPreparation?.has_msds ? '■ 유 / □ 무' : '□ 유 / ■ 무'}</td></tr>
                                            <tr><td>8</td><td className="text-start">기계·기구 자체검사 결과</td><td>{modalPreparation?.has_machine_inspection ? '■ 유 / □ 무' : '□ 유 / ■ 무'}</td></tr>
                                            <tr><td>9</td><td className="text-start">특별안전교육 필요 유무</td><td>{modalPreparation?.need_special_education ? '■ 유 / □ 무' : '□ 유 / ■ 무'}</td></tr>
                                            <tr><td>10</td><td className="text-start">안전작업허가증 필요작업</td><td>{modalPreparation?.need_work_permit ? '■ 유 / □ 무' : '□ 유 / ■ 무'}</td></tr>
                                        </tbody>
                                    </table>

                                    {/* 매트릭스: 공정 사용 시에만 표시 */}
                                    {modalUseProcess && (
                                        <>
                                            <div className="section-title">2. 유해위험요인 파악</div>
                                            <table className="table table-bordered align-middle small text-center" style={{ marginTop: '20px' }}>
                                                <thead className="table-light" style={{ background: '#f8fafc' }}>
                                                    <tr>
                                                        <th rowSpan={2} style={{ width: '22%' }}>공정(작업)</th>
                                                        <th colSpan={6}>위험 분류별 식별 여부</th>
                                                    </tr>
                                                    <tr>
                                                        <th>기계적</th><th>전기적</th><th>화학적</th><th>생물학적</th><th>작업특성</th><th>작업환경</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {displayProcs.length === 0 ? (
                                                        <tr><td colSpan={7} style={{ padding: '20px' }}>평가 대상 공정이 없습니다.</td></tr>
                                                    ) : displayProcs.map((p, idx) => {
                                                        const pName = (p.name || '').trim();

                                                        // 해당 공정(pName)과 연관된 평가 항목들을 정확히 추출 (필드명 전면 호환)
                                                        const procsEvals = displayEvals.filter(e => {
                                                            const eName = (e.processName || e.process_name || '').trim();
                                                            if (!eName && (pName === '공정 미지정' || !pName)) return true;
                                                            if (eName && pName) {
                                                                return eName === pName || eName.includes(pName) || pName.includes(eName);
                                                            }
                                                            return false;
                                                        });

                                                        const hasCatStr = (str) => procsEvals.some(e => {
                                                            const catName = String(e.categoryName || e.category_name || '');
                                                            if (catName.includes(str)) return true;
                                                            let num = '';
                                                            if (str === '기계') num = '1';
                                                            if (str === '전기') num = '2';
                                                            if (str === '화학') num = '3';
                                                            if (str === '생물') num = '4';
                                                            if (str === '특성') num = '5';
                                                            if (str === '환경') num = '6';
                                                            const code = String(e.causeCode || e.cause_code || e.code || '');
                                                            const name = String(e.causeName || e.cause_name || e.hazardCause || e.hazard_cause || e.name || '');
                                                            return num && (code.startsWith(`${num}.`) || code === num || name.startsWith(`${num}.`) || catName.startsWith(`${num}.`));
                                                        }) ? 'O' : '';
                                                        return (
                                                            <tr key={`mat-${p.id || idx}`}>
                                                                <td className="fw-bold">{p.name}</td>
                                                                <td style={{ color: '#2563eb', fontWeight: 'bold' }}>{hasCatStr('기계')}</td>
                                                                <td style={{ color: '#2563eb', fontWeight: 'bold' }}>{hasCatStr('전기')}</td>
                                                                <td style={{ color: '#2563eb', fontWeight: 'bold' }}>{hasCatStr('화학')}</td>
                                                                <td style={{ color: '#2563eb', fontWeight: 'bold' }}>{hasCatStr('생물')}</td>
                                                                <td style={{ color: '#2563eb', fontWeight: 'bold' }}>{hasCatStr('특성')}</td>
                                                                <td style={{ color: '#2563eb', fontWeight: 'bold' }}>{hasCatStr('환경')}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </>
                                    )}
                                </div>
                            )}

                            {/* 3P: 위험성 결정 및 감소대책 수립 평가표 (단일 대형 테이블) */}
                            {localPrintSections.evals && (
                                <div className="a4-page page-break">
                                    <div className="section-title">3. 위험성 결정 및 감소대책 수립 평가표</div>
                                    <table className="table table-bordered align-middle small text-center" style={{ fontSize: '0.85rem' }}>
                                        <thead className="table-light" style={{ background: '#f8fafc' }}>
                                            <tr>
                                                <th style={{ width: '18%', verticalAlign: 'middle', padding: '10px 6px' }}>위험원인</th>
                                                <th style={{ width: '41%', verticalAlign: 'middle', padding: '10px 6px' }}>유해·위험요인 파악 (현재 조치)</th>
                                                <th style={{ width: '41%', verticalAlign: 'middle', padding: '10px 6px' }}>개선(감소)대책 수립</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {displayEvals.length === 0 ? (
                                                <tr><td colSpan={3} style={{ padding: '20px' }}>등록된 위험성 평가 내역이 없습니다.</td></tr>
                                            ) : displayEvals.map((item, idx) => {
                                                const ev = item.evaluation || {};
                                                const showProcess = rowSpans[idx] !== undefined;

                                                const causeCodeStr = item.causeCode ? `[${item.causeCode}] ` : '';
                                                const causeText = `${causeCodeStr}${item.causeName || '-'}`;

                                                const dueDateText = ev.dueDate ? ev.dueDate.substring(0, 10) : '';
                                                const doneDateText = ev.doneDate ? ev.doneDate.substring(0, 10) : '';

                                                const statusText = ev.actionStatus === 'completed'
                                                    ? `완료 (${doneDateText})`
                                                    : (ev.actionStatus === 'in_progress' ? '진행중' : '미완료 (대기)');

                                                const statusColor = ev.actionStatus === 'completed' ? '#16a34a' : (ev.actionStatus === 'in_progress' ? '#2563eb' : '#dc2626');

                                                return (
                                                    <React.Fragment key={item.matrixCheckId || idx}>
                                                        {showProcess && (
                                                            <tr style={{ pageBreakInside: 'avoid', breakInside: 'avoid', borderTop: '2px solid #64748b' }}>
                                                                <td colSpan={3} style={{ padding: '8px 12px', borderBottom: '1px solid #cbd5e1', background: '#f1f5f9' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                        <div style={{ fontWeight: 'bold', color: '#0f172a', fontSize: '12.5px', flex: 1, minWidth: 0, marginRight: '15px' }}>
                                                                            📌 공정명 : {item.processName}
                                                                        </div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '11.5px', flexShrink: 0, whiteSpace: 'nowrap' }}>
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                                <span style={{ color: '#475569', fontWeight: 'bold', fontSize: '11px' }}>개선전:</span>
                                                                                {getRiskDisplay(ev.riskBefore)}
                                                                            </div>
                                                                            <div style={{ width: '1px', height: '14px', backgroundColor: '#cbd5e1' }} />
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                                <span style={{ color: '#475569', fontWeight: 'bold', fontSize: '11px' }}>개선후:</span>
                                                                                {getRiskDisplay(ev.riskAfter)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                        <tr style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                                                            <td className="text-start fw-bold" style={{ width: '18%', padding: '10px 12px', verticalAlign: 'top', color: '#0f172a', whiteSpace: 'pre-wrap', background: '#fff' }}>
                                                                {causeText}
                                                            </td>
                                                            <td className="text-start" style={{ width: '41%', padding: '8px 12px', verticalAlign: 'top', background: '#fff' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px dashed #b0bec5', paddingBottom: '6px', marginBottom: '8px' }}>
                                                                    <div style={{ fontSize: '11px', color: '#475569' }}>
                                                                        {dueDateText && (
                                                                            <span>
                                                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#475569" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '4px', verticalAlign: '-1px' }}><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                                                                                <strong style={{ color: '#1e293b' }}>조치기한 :</strong> {dueDateText}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <span style={{ backgroundColor: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', fontSize: '10px', fontWeight: 'bold', padding: '2px 6px', borderRadius: '4px' }}>
                                                                        유해위험요인 파악 (현재 조치)
                                                                    </span>
                                                                </div>
                                                                <div style={{ color: '#1e293b', lineHeight: '1.6', fontSize: '11.5px', whiteSpace: 'pre-wrap' }}>{ev.currentMeasure || '-'}</div>
                                                            </td>
                                                            <td className="text-start" style={{ width: '41%', padding: '8px 12px', verticalAlign: 'top', background: '#fff' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px dashed #b0bec5', paddingBottom: '6px', marginBottom: '8px' }}>
                                                                    <div style={{ fontSize: '11px', color: '#475569' }}>
                                                                        <span>
                                                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={statusColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '4px', verticalAlign: '-1px' }}><polyline points="20 6 9 17 4 12" /></svg>
                                                                            <strong style={{ color: '#1e293b' }}>조치결과 :</strong> <span style={{ color: statusColor, fontWeight: 'bold' }}>{statusText}</span>
                                                                        </span>
                                                                    </div>
                                                                    <span style={{ backgroundColor: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', fontSize: '10px', fontWeight: 'bold', padding: '2px 6px', borderRadius: '4px' }}>
                                                                        개선(감소)대책 수립
                                                                    </span>
                                                                </div>
                                                                <div style={{ color: '#1e293b', lineHeight: '1.6', fontSize: '11.5px', whiteSpace: 'pre-wrap' }}>{ev.action || '-'}</div>
                                                            </td>
                                                        </tr>
                                                        <tr style={{ pageBreakInside: 'avoid', breakInside: 'avoid', background: '#fafafa' }}>
                                                            <td colSpan={3} style={{ padding: '6px 10px', fontSize: '11px', borderBottom: '1px solid #cbd5e1' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', color: '#475569', minHeight: '22px' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0, marginRight: '8px' }}>
                                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#475569" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '4px' }}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                                                                        <strong style={{ color: '#1e293b', fontSize: '12px' }}>담당자 :</strong>
                                                                    </div>
                                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 20px', flex: 1, alignItems: 'center' }}>
                                                                        {(ev.assignees && ev.assignees.length > 0) ? ev.assignees.map((a, i) => (
                                                                            <div key={i} style={{ display: 'inline-flex', alignItems: 'center', padding: '4px 0' }}>
                                                                                <span style={{ color: '#1e293b', fontWeight: 'bold', fontSize: '12px' }}>{a.name} {a.position || ''}</span>
                                                                                <span style={{ color: '#94a3b8', fontSize: '12px', marginLeft: '6px' }}>(인)</span>
                                                                            </div>
                                                                        )) : '-'}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {/* 4P: 개선 결과 (조치 전/후 사진대지) (그리드 레이아웃) */}
                            {localPrintSections.photos && (
                                <div className="a4-page page-break" style={{ minHeight: 'auto' }}>
                                    <div className="section-title">4. 개선 결과 (조치 전/후 사진대지)</div>

                                    {displayPhotos.length === 0 ? (
                                        <div style={{ padding: '40px', textAlign: 'center', color: '#64748b', border: '1px solid #94a3b8', background: '#f8fafc' }}>
                                            조치 전/후 대상 내역이 없습니다.
                                        </div>
                                    ) : (
                                        <div className="photo-grid-container" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                            {displayPhotos.map((photo, idx) => (
                                                <div key={idx} style={{ pageBreakInside: 'avoid', border: '1px solid #cbd5e1', background: '#fff' }}>
                                                    <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed', margin: 0 }}>
                                                        <tbody>
                                                            <tr>
                                                                <th style={{ width: '18%', background: '#f8fafc', borderBottom: '1px solid #cbd5e1', borderRight: '1px solid #cbd5e1', padding: '6px 8px', fontSize: '12px', color: '#475569', textAlign: 'center', fontWeight: 'bold' }}>공정 / 위험분류</th>
                                                                <td style={{ width: '82%', borderBottom: '1px solid #cbd5e1', padding: '6px 10px', fontSize: '12px', color: '#0f172a', fontWeight: 'bold', wordBreak: 'keep-all', lineHeight: '1.4', whiteSpace: 'pre-wrap', textAlign: 'left' }}>{photo.breadcrumb}</td>
                                                            </tr>
                                                            <tr>
                                                                <th style={{ background: '#f8fafc', borderBottom: '1px solid #cbd5e1', borderRight: '1px solid #cbd5e1', padding: '6px 8px', fontSize: '12px', color: '#ef4444', textAlign: 'center', fontWeight: 'bold' }}>유해위험요인 파악</th>
                                                                <td style={{ borderBottom: '1px solid #cbd5e1', padding: '6px 10px', fontSize: '12px', color: '#1e293b', wordBreak: 'keep-all', lineHeight: '1.4', whiteSpace: 'pre-wrap', textAlign: 'left' }}>{photo.currentMeasure}</td>
                                                            </tr>
                                                            <tr style={{ height: 'auto' }}>
                                                                <td colSpan="2" style={{ padding: 0, height: 'auto' }}>
                                                                    <div style={{ display: 'flex', width: '100%', alignItems: 'stretch' }}>
                                                                        {/* 조치 전 (Before) - 50% */}
                                                                        <div style={{ flex: '1 1 50%', borderRight: '1px solid #cbd5e1', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                                                            <div style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'center', padding: '6px 0', color: '#0f172a', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>조치 전 (Before)</div>
                                                                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', minHeight: '180px', padding: '10px' }}>
                                                                                {photo.before ? (
                                                                                    <img src={photo.before} style={{ maxWidth: '100%', maxHeight: '220px', objectFit: 'contain', display: 'block', margin: '0 auto' }} alt="before" />
                                                                                ) : <span style={{ color: '#94a3b8', fontSize: '12px' }}>사진 없음</span>}
                                                                            </div>
                                                                        </div>

                                                                        {/* 조치 후 (After) - 50% */}
                                                                        <div style={{ flex: '1 1 50%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                                                            <div style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'center', padding: '6px 0', color: '#0f172a', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>조치 후 (After)</div>
                                                                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', minHeight: '180px', padding: '10px' }}>
                                                                                {photo.after ? (
                                                                                    <img src={photo.after} style={{ maxWidth: '100%', maxHeight: '220px', objectFit: 'contain', display: 'block', margin: '0 auto' }} alt="after" />
                                                                                ) : <span style={{ color: '#94a3b8', fontSize: '12px' }}>사진 없음</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* 5. 위험성평가 종합 총평 */}
                            {localPrintSections.conclusion && modalSummary?.conclusion && (
                                <div className="a4-page page-break" style={{ minHeight: 'auto' }}>
                                    <div className="section-title">5. 위험성평가 종합 총평</div>
                                    <table className="table table-bordered align-middle" style={{ width: '100%', fontSize: '11.5px', marginBottom: '20px' }}>
                                        <tbody>
                                            <tr>
                                                <th style={{ width: '15%', background: '#f8fafc', padding: '8px 10px', textAlign: 'center', fontWeight: 'bold' }}>작성자</th>
                                                <td style={{ width: '35%', padding: '8px 10px', textAlign: 'left', fontWeight: 'bold', color: '#1e293b' }}>
                                                    {modalSummary.writer || selectedProj?.managerName || projWriter || '-'}
                                                </td>
                                                <th style={{ width: '15%', background: '#f8fafc', padding: '8px 10px', textAlign: 'center', fontWeight: 'bold' }}>작성일</th>
                                                <td style={{ width: '35%', padding: '8px 10px', textAlign: 'left', fontWeight: 'bold', color: '#1e293b' }}>
                                                    {modalSummary.writeDate || projWriterDate || '-'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{ background: '#f8fafc', padding: '12px 10px', textAlign: 'center', fontWeight: 'bold', verticalAlign: 'top' }}>종합 총평</th>
                                                <td colSpan={3} className="text-start align-top-content" style={{ height: '440px', padding: '15px', verticalAlign: 'top', lineHeight: '1.6', color: '#0f172a' }} dangerouslySetInnerHTML={{ __html: modalSummary.conclusion || '' }} />
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {/* 회의록 (N건 - 1건당 1페이지 강제 할당 및 높이 440px) */}
                            {localPrintSections.meetings && displayMeetings.map((mt, i) => (
                                <div className="a4-page page-break" key={`mt-${i}`}>
                                    <div className="section-title">위험성평가 회의록 ({i + 1}/{displayMeetings.length})</div>
                                    <table className="table table-bordered text-center align-middle" style={{ fontSize: '0.85rem', marginBottom: '20px' }}>
                                        <tbody>
                                            <tr>
                                                <th style={{ width: '15%', background: '#f8fafc' }}>제목</th>
                                                <td className="text-start fw-bold" style={{ width: '50%' }}>{mt.title}</td>
                                                <th style={{ width: '15%', background: '#f8fafc' }}>일시</th>
                                                <td className="text-center" style={{ width: '20%', whiteSpace: 'nowrap' }}>{mt.date ? mt.date.split('T')[0] : '-'}</td>
                                            </tr>
                                            <tr>
                                                <th className="align-top-content" style={{ background: '#f8fafc', paddingTop: '15px' }}>회의내용</th>
                                                <td colSpan={3} className="text-start align-top-content" style={{ height: '440px', padding: '15px', verticalAlign: 'top' }} dangerouslySetInnerHTML={{ __html: mt.content || '' }} />
                                            </tr>
                                            {mt.attendees && (
                                                <tr>
                                                    <th style={{ background: '#f8fafc', padding: '12px 10px', verticalAlign: 'middle' }}>
                                                        참석자 <span style={{ fontSize: '11px', color: '#64748b', fontWeight: 'normal' }}>(총 {mt.attendees.split(',').length}명)</span>
                                                    </th>
                                                    <td colSpan={3} className="text-start align-top-content" style={{ padding: '15px', verticalAlign: 'top' }}>
                                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px 35px' }}>
                                                            {mt.attendees.split(',').map((att, attIdx) => (
                                                                <div key={attIdx} style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                    <span style={{ fontSize: '14px', color: '#0f172a' }}>{att.trim()}</span>
                                                                    <span style={{ color: '#94a3b8', fontSize: '14px', marginLeft: '6px' }}>(인)</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>



                                    {/* 사진 첨부 2열 그리드 (본문에 이미지가 없고 첨부파일 사진만 있을 때 표시하여 중복 방지) */}
                                    {!/<img[^>]+src=/i.test(mt.content || '') && Array.isArray(mt.files) && mt.files.filter(f => f.mimeType && f.mimeType.startsWith('image/')).length > 0 && (
                                        <div style={{ marginTop: '16px' }}>
                                            <div style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '10px' }}>■ 사진 첨부 (증빙자료)</div>
                                            <div style={{ display: 'block', fontSize: 0 }}>
                                                {mt.files.filter(f => f.mimeType && f.mimeType.startsWith('image/')).map((file, fIdx) => (
                                                    <div key={file.id || fIdx} style={{
                                                        display: 'inline-block', width: '48%',
                                                        marginRight: fIdx % 2 === 0 ? '4%' : '0',
                                                        marginBottom: '1.5rem',
                                                        border: '1px solid #dee2e6', boxSizing: 'border-box',
                                                        verticalAlign: 'top', pageBreakInside: 'avoid',
                                                        backgroundColor: '#ffffff',
                                                        WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '12px', fontWeight: 'bold',
                                                            backgroundColor: '#f1f5f9', borderBottom: '1px solid #dee2e6',
                                                            padding: '8px 12px', textAlign: 'left', color: '#1e293b',
                                                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                                            WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact'
                                                        }}>{file.originalName || file.name}</div>
                                                        <div style={{ height: '220px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
                                                            <img src={file.path} alt={file.originalName || file.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* (회의록 하단 서명부 표 안으로 이동 완료) */}

                                </div>
                            ))}

                            {/* 6. 근로자 안전보건교육 일지 (N건 - 1건당 1페이지 강제 할당 및 높이 440px) */}
                            {localPrintSections.trainings && (displayTrainings.length === 0 ? (
                                <div className="a4-page page-break" style={{ minHeight: 'auto' }}>
                                    <div className="section-title">6. 근로자 안전보건교육 일지</div>
                                    <div style={{ padding: '20px', border: '1px solid #94a3b8', textAlign: 'center', background: '#f8fafc', color: '#64748b' }}>등록된 교육 일지가 없습니다.</div>
                                </div>
                            ) : displayTrainings.map((tr, i) => (
                                <div className="a4-page page-break" key={`tr-${i}`}>
                                    <div className="section-title">6. 근로자 안전보건교육 일지 ({i + 1}/{displayTrainings.length})</div>
                                    <table className="table table-bordered text-center align-middle" style={{ fontSize: '0.85rem', marginBottom: '20px' }}>
                                        <tbody>
                                            <tr>
                                                <th style={{ background: '#f8fafc' }}>제목</th>
                                                <td colSpan={3} className="text-start fw-bold">{tr.title}</td>
                                            </tr>
                                            <tr>
                                                <th style={{ width: '15%', background: '#f8fafc' }}>일시</th>
                                                <td className="text-start" style={{ width: '35%', whiteSpace: 'nowrap' }}>{tr.date ? tr.date.split('T')[0] : '-'}</td>
                                                <th style={{ width: '15%', background: '#f8fafc' }}>강사</th>
                                                <td className="text-start" style={{ width: '35%' }}>{tr.instructor}</td>
                                            </tr>
                                            <tr>
                                                <th className="align-top-content" style={{ background: '#f8fafc', paddingTop: '15px' }}>교육내용</th>
                                                <td colSpan={3} className="text-start align-top-content" style={{ height: '440px', padding: '15px', verticalAlign: 'top' }} dangerouslySetInnerHTML={{ __html: tr.content || '' }} />
                                            </tr>
                                            {tr.attendees && (() => {
                                                let rawList = [];
                                                if (Array.isArray(tr.attendees)) {
                                                    rawList = tr.attendees;
                                                } else if (typeof tr.attendees === 'string') {
                                                    const trimmed = tr.attendees.trim();
                                                    if (trimmed.startsWith('[')) {
                                                        try { rawList = JSON.parse(trimmed); } catch (e) { rawList = trimmed.split(','); }
                                                    } else {
                                                        rawList = trimmed.split(',');
                                                    }
                                                }
                                                const formattedList = rawList.map(att => {
                                                    if (!att) return '';
                                                    if (typeof att === 'object') {
                                                        const name = att.name || att.user_name || att.userName || att.text || '';
                                                        const pos = att.position || att.user_position || att.userPosition || att.duty || att.rank || '';
                                                        return `${name} ${pos}`.trim();
                                                    }
                                                    if (typeof att === 'string') {
                                                        const strTrim = att.trim();
                                                        if (strTrim.startsWith('{')) {
                                                            try {
                                                                const parsed = JSON.parse(strTrim);
                                                                const name = parsed.name || parsed.user_name || parsed.userName || parsed.text || '';
                                                                const pos = parsed.position || parsed.user_position || parsed.userPosition || parsed.duty || parsed.rank || '';
                                                                return `${name} ${pos}`.trim();
                                                            } catch (e) { }
                                                        }
                                                        return strTrim;
                                                    }
                                                    return String(att);
                                                }).filter(Boolean);

                                                return (
                                                    <tr>
                                                        <th style={{ background: '#f8fafc', padding: '12px 10px', verticalAlign: 'middle' }}>
                                                            교육 대상자 <span style={{ fontSize: '11px', color: '#64748b', fontWeight: 'normal' }}>(총 {formattedList.length}명)</span>
                                                        </th>
                                                        <td colSpan={3} className="text-start align-top-content" style={{ padding: '15px', verticalAlign: 'top' }}>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px 35px' }}>
                                                                {formattedList.map((attName, attIdx) => (
                                                                    <div key={attIdx} style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                        <span style={{ fontSize: '14px', color: '#0f172a' }}>{attName}</span>
                                                                        <span style={{ color: '#94a3b8', fontSize: '14px', marginLeft: '6px' }}>(인)</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })()}
                                        </tbody>
                                    </table>



                                    {/* 사진 첨부 2열 그리드 (본문에 이미지가 없고 첨부파일 사진만 있을 때 표시하여 중복 방지) */}
                                    {!/<img[^>]+src=/i.test(tr.content || '') && Array.isArray(tr.files) && tr.files.filter(f => f.mimeType && f.mimeType.startsWith('image/')).length > 0 && (
                                        <div style={{ marginTop: '16px' }}>
                                            <div style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '10px' }}>■ 사진 첨부 (증빙자료)</div>
                                            <div style={{ display: 'block', fontSize: 0 }}>
                                                {tr.files.filter(f => f.mimeType && f.mimeType.startsWith('image/')).map((file, fIdx) => (
                                                    <div key={file.id || fIdx} style={{
                                                        display: 'inline-block', width: '48%',
                                                        marginRight: fIdx % 2 === 0 ? '4%' : '0',
                                                        marginBottom: '1.5rem',
                                                        border: '1px solid #dee2e6', boxSizing: 'border-box',
                                                        verticalAlign: 'top', pageBreakInside: 'avoid',
                                                        backgroundColor: '#ffffff',
                                                        WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact'
                                                    }}>
                                                        <div style={{
                                                            fontSize: '12px', fontWeight: 'bold',
                                                            backgroundColor: '#f1f5f9', borderBottom: '1px solid #dee2e6',
                                                            padding: '8px 12px', textAlign: 'left', color: '#1e293b',
                                                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                                            WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact'
                                                        }}>{file.originalName || file.name}</div>
                                                        <div style={{ height: '220px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
                                                            <img src={file.path} alt={file.originalName || file.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* (교육일지 하단 서명부 표 안으로 이동 완료) */}

                                </div>
                            )))}

                        </div>
                    )}
                </div>

                {/* 모달 하단 툴바 (결재선 선택 및 인쇄/닫기 버튼) */}
                <div className="text-dark px-4 py-3 d-flex justify-content-between align-items-center no-print border-top" style={{ backgroundColor: '#f1f5f9' }}>
                    <div className="d-flex align-items-center gap-2">
                        {appDocs.length > 1 && localPrintSections.cover && (
                            <>
                                <span style={{ fontSize: '0.85rem', color: '#475569', fontWeight: 600, whiteSpace: 'nowrap' }}>표지 결재선 선택:</span>
                                <select
                                    className="form-select form-select-sm"
                                    value={selectedAppDocIndex}
                                    onChange={(e) => setSelectedAppDocIndex(Number(e.target.value))}
                                    style={{ width: 'auto', minWidth: '220px', maxWidth: '440px', backgroundColor: '#fff', color: '#1e293b', border: '1px solid #cbd5e1' }}
                                >
                                    {appDocs.map((doc, idx) => (
                                        <option key={idx} value={idx}>
                                            {idx === 0 ? `[기본] ${doc.doc_title || doc.title || `결재문서 ${idx + 1}`}` : (doc.doc_title || doc.title || `결재문서 ${idx + 1}`)}
                                        </option>
                                    ))}
                                </select>
                            </>
                        )}
                    </div>
                    <div className="d-flex gap-2">
                        <button type="button" className="btn btn-primary btn-sm fw-bold px-3 d-flex align-items-center gap-1.5" onClick={handlePrint}>
                            <i className="bi bi-printer-fill"></i> 바로 인쇄 / PDF 저장
                        </button>
                        <button type="button" className="btn btn-dark btn-sm px-3" onClick={() => setActiveModal(null)}>
                            닫기
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default SafetyReportViewerModal;
